/**
 * Static registry of Lucide icons used by installed learning apps.
 *
 * The `installed_apps.icon` column in D1 stores a Lucide component name as a
 * string (e.g. `"BookOpen"`). This map resolves that string to a concrete
 * React component at render time, so bundles stay tree-shaken — a dynamic
 * `Icons[name]` lookup would force Vite to ship every Lucide icon.
 *
 * When adding a new learning app, add its icon here and in the migration that
 * inserts its `installed_apps` row.
 */
import {
  BookA,
  BookOpen,
  Footprints,
  GraduationCap,
  Landmark,
  Palette,
  MessageSquareQuote,
  Table2,
  Target,
  type LucideIcon,
} from 'lucide-react';

export const APP_ICONS: Record<string, LucideIcon> = {
  BookOpen,
  Target,
  Footprints,
  Landmark, // einbuergerungstest (Bundestag/state institutions)
  Palette, // adjectives & adverbs (describing words)
  Table2, // konjugation (the conjugation table itself)
  GraduationCap, // grammatik (one rule a day)
  BookA, // einbuergerungstest-vokabeln (vocabulary from the catalog)
  MessageSquareQuote, // reserved for a future Expressions app
};

/** Resolve a Lucide icon name to its component. Falls back to BookOpen. */
export function getAppIcon(name: string | null | undefined): LucideIcon {
  if (!name) return BookOpen;
  return APP_ICONS[name] ?? BookOpen;
}
